export default __webpack_public_path__ + "static/media/login-background.344b9c39.png";